import { ListItem, ListItemLabel } from "baseui/list";
import { ValueDisplay } from "../../components/ValueDisplay";
import { ICostRate } from "./types";
import { BsCurrencyExchange } from "react-icons/bs";
import getSymbolFromCurrency from "currency-symbol-map";
import { defaultCurrencyCode } from "../../../utils/currency";
import { SelectableListItem } from "../../../components/SelectableListItem";


interface SelectableCostRateListItemProps extends ICostRate {
    isSelected?: boolean
    onSelect?: (item: ICostRate) => void,
    canDelete?: boolean
    canEdit?: boolean
}
const SelectableCostRateListItem = (props: SelectableCostRateListItemProps) => {
    
    const currencySymbol = getSymbolFromCurrency(props.currencyCode ?? defaultCurrencyCode);

    return (
        <SelectableListItem
            key={props.id}
            item={props}
            onSelect={props.onSelect}
            isSelected={props.isSelected}
            artworkSize={'MEDIUM'}
            artwork={() => <BsCurrencyExchange size={'1.5em'}></BsCurrencyExchange>}
            endEnhancer={() => (
                <>
                    <ValueDisplay small value={props.valuePerUnit} dimension={`${currencySymbol}/Unit`}></ValueDisplay>
                </>
            )}        >
            <ListItemLabel>{props.name}</ListItemLabel>
        </SelectableListItem>
    )
}

export default SelectableCostRateListItem;